(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base-portlet/js/base-portlet"), require("map-portlet/js/map-portlet"));
	else if(typeof define === 'function' && define.amd)
		define(["base-portlet/js/base-portlet", "map-portlet/js/map-portlet"], factory);
	else if(typeof exports === 'object')
		exports["territorial-portlet"] = factory(require("base-portlet/js/base-portlet"), require("map-portlet/js/map-portlet"));
	else
		root["territorial-portlet"] = factory(root["base-portlet/js/base-portlet"], root["map-portlet/js/map-portlet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_4__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	exports.GlobalTerritorialKommune = exports.GlobalTerritorialKreis = exports.GlobalTerritorialRP = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _basePortlet = __webpack_require__(2);
	
	var _MapLayer = __webpack_require__(3);
	
	var GlobalTerritorialRP = _extends({}, _MapLayer.TerritoryRpLayer, {
	    id: 'fliwas_territories_rp',
	    uuid: 'fliwas_territories_rp',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	var GlobalTerritorialKreis = _extends({}, _MapLayer.TerritoryKreisLayer, {
	    id: 'fliwas_territories_kreis',
	    uuid: 'fliwas_territories_kreis',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	var GlobalTerritorialKommune = _extends({}, _MapLayer.TerritoryKommuneLayer, {
	    id: 'fliwas_territories_kommune',
	    uuid: 'fliwas_territories_kommune',
	    controller: _basePortlet.BaseRemoteVectorLayerController
	});
	
	exports.GlobalTerritorialRP = GlobalTerritorialRP;
	exports.GlobalTerritorialKreis = GlobalTerritorialKreis;
	exports.GlobalTerritorialKommune = GlobalTerritorialKommune;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TerritoryKommuneLayer = exports.TerritoryKreisLayer = exports.TerritoryRpLayer = undefined;
	
	var _mapPortlet = __webpack_require__(4);
	
	var _Constants = __webpack_require__(5);
	
	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Carsten Bühler
	 * Date: 22.03.2016
	 *
	 */
	
	var TerritoryRpLayer = exports.TerritoryRpLayer = {
	    id: 'fliwas_territories_rp',
	    uuid: 'fliwas_territories_rp',
	    title: 'Regierungspräsidien',
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            "type": "TerritorialEntity",
	            "administrativeRank": _Constants.AdministrativeRank.RP
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        }
	    }
	};
	var TerritoryKreisLayer = exports.TerritoryKreisLayer = {
	    id: 'fliwas_territories_kreis',
	    uuid: 'fliwas_territories_kreis',
	    title: 'Kreise/Kreisfreie Städte',
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            "type": "TerritorialEntity",
	            "administrativeRank": _Constants.AdministrativeRank.DISTRICT
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        }
	    }
	};
	var TerritoryKommuneLayer = exports.TerritoryKommuneLayer = {
	    id: 'fliwas_territories_kommune',
	    uuid: 'fliwas_territories_kommune',
	    title: 'Kommunen/Gemeinden',
	    type: _mapPortlet.ClassNames.LayerDataSource,
	    typeKey: 'remote-vector-layer',
	    params: {},
	    config: {
	        servicePath: '/o/vector-tiles?x={x}&y={y}&z={z}&filter=',
	        filter: {
	            "type": "TerritorialEntity",
	            "administrativeRank": _Constants.AdministrativeRank.COMMUNE
	        },
	        style: {
	            color: '#326487',
	            fillColor: '#68869B'
	        }
	    }
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var AdministrativeRank = exports.AdministrativeRank = {
	    RP: 3,
	    DISTRICT: 4,
	    COMMUNE: 6
	};

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// territorial-portlet.js